import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"
import _imports_0 from '@/static/icons/close.svg'
import _imports_1 from '@/static/icons/chevron-right.svg'


const _hoisted_1 = {
  key: 0,
  class: "floating-add-to-cart__content-wrap"
}
const _hoisted_2 = { class: "floating-add-to-cart__content" }
const _hoisted_3 = { class: "floating-add-to-cart__sizes-container" }
const _hoisted_4 = { class: "floating-add-to-cart__size-header" }
const _hoisted_5 = { class: "floating-add-to-cart__sizes" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = { class: "floating-add-to-cart__controls-wrap" }
const _hoisted_9 = { class: "floating-add-to-cart__name-price" }
const _hoisted_10 = { class: "floating-add-to-cart__name" }
const _hoisted_11 = { class: "floating-add-to-cart__price" }
const _hoisted_12 = {
  key: 0,
  class: "floating-add-to-cart__campaign-price"
}
const _hoisted_13 = {
  key: 1,
  class: "floating-add-to-cart__campaign-discount"
}
const _hoisted_14 = ["disabled"]
const _hoisted_15 = { class: "floating-add-to-cart__guides floating-add-to-cart__guides-modal" }
const _hoisted_16 = { class: "floating-add-to-cart__header" }
const _hoisted_17 = { class: "floating-add-to-cart__size-guide" }

import {
  computed,
  inject,
  ref,
  watch,
} from 'vue';

import useWebsiteTexts from '@/composables/useWebsiteTexts';
import useSizeDisplay from '@/composables/useSizeDisplay';
import useWindowResize from '@/composables/useWindowResize';

import scrollLock from '../../helpers/scroll-lock';

import SizeSelect from './SizeSelect.vue';
import SizeGuideAccordion from './SizeGuide/SizeGuideAccordion.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'FloatingAddToCart',
  setup(__props, { expose }) {

expose({
  close,
});

const { websiteText } = useWebsiteTexts();
const { getSizeName } = useSizeDisplay();
const { isMobile } = useWindowResize();

const addToCartContext = inject('addToCartContext') as any;

const controls = ref<HTMLDivElement | null>(null);
const sizeDropDownIsOpen = ref(false);
const sizeGuideOpen = ref(false);

const product = computed(() => addToCartContext.product.value);
const productName = computed(() => product.value.fields._name);
const productPrice = computed(() => product.value.price);
const productCampaignPrice = computed(() => product.value.campaignPrice);
const productCampaignDiscount = computed(() => product.value.campaignDiscount);
const selectedSize = computed(() => addToCartContext.selectedSize?.value);

const selectedSizeCaption = computed(
  () => getSizeName(selectedSize.value?.sizeName) || '',
);

const selectedSizeHasStock = computed(
  () => addToCartContext.selectedSizeHasStock.value,
);

const isComingSoon = computed(() => addToCartContext.isComingSoon);

/* eslint no-confusing-arrow: "off" */
const buttonLabel = computed(() => selectedSizeHasStock.value
  ? (websiteText('productbuy').value || 'productbuy')
  : addToCartContext.outOfStockButtonLabel.value);

const hasSizes = computed(() => addToCartContext.hasSizes.value);

watch(sizeDropDownIsOpen, () => {
  const scrollbarWidth = window?.innerWidth - document?.body?.offsetWidth;
  if (!controls.value) return;
  if (sizeDropDownIsOpen.value) {
    scrollLock.enable();
    if (!isMobile.value) {
      controls.value.style.paddingRight = `${15 + scrollbarWidth}px`;
    }
  } else {
    scrollLock.disable();
    controls.value.style.paddingRight = '15px';
  }
});

function selectSize(size) {
  addToCartContext.selectVariant(size);
}

function addToCart() {
  addToCartContext.addSelectedToCart();
}

function close() {
  sizeDropDownIsOpen.value = false;
  sizeGuideOpen.value = false;
}

function toggleSizeDropdown() {
  sizeDropDownIsOpen.value = !sizeDropDownIsOpen.value;
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref: "fatc",
    class: _normalizeClass(["floating-add-to-cart", {
      'floating-add-to-cart--guides-modal-open': sizeGuideOpen.value,
      'floating-add-to-cart--static': !sizeDropDownIsOpen.value,
    }])
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["floating-add-to-cart__backdrop", { 'floating-add-to-cart__backdrop--active': sizeDropDownIsOpen.value }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (close()))
    }, null, 2),
    (sizeDropDownIsOpen.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(SizeGuideAccordion, { class: "floating-add-to-cart__content-size-guide" }),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(websiteText)('addtocart__select_size').value ||
              'addtocart__select_size'), 1),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(SizeSelect, {
                  sizes: _unref(addToCartContext).sizes.value || [],
                  "selected-size": _unref(addToCartContext).selectedSize?.value,
                  "show-checkmark": true,
                  onSelect: _cache[1] || (_cache[1] = ($event: any) => (selectSize($event)))
                }, null, 8, ["sizes", "selected-size"])
              ]),
              _createElementVNode("div", {
                class: "floating-add-to-cart__open-size-guide",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (sizeGuideOpen.value = true))
              }, _toDisplayString(_unref(websiteText)('addtocart__size_info').value ||
              'addtocart__size_info'), 1)
            ]),
            _createElementVNode("button", {
              class: "clean-button floating-add-to-cart__close",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (close()))
            }, _hoisted_7)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", {
        class: "floating-add-to-cart__controls",
        ref_key: "controls",
        ref: controls
      }, [
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, _toDisplayString(_unref(productName)), 1),
          _createElementVNode("div", {
            class: _normalizeClass(["floating-add-to-cart__price-container", {
              'floating-add-to-cart__price-container--campaign':
                _unref(productCampaignPrice),
            }])
          }, [
            _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(productPrice)), 1),
            (_unref(productCampaignPrice))
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(productCampaignPrice)), 1))
              : _createCommentVNode("", true),
            (_unref(productCampaignPrice))
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, " (" + _toDisplayString(_unref(productCampaignDiscount)) + "%) ", 1))
              : _createCommentVNode("", true)
          ], 2)
        ]),
        (_unref(hasSizes))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "clean-button floating-add-to-cart__drop-down",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (toggleSizeDropdown()))
            }, [
              _createTextVNode(_toDisplayString(_unref(selectedSizeCaption)) + " ", 1),
              _createElementVNode("span", {
                class: _normalizeClass(["floating-add-to-cart__drop-down-arrow", { 'floating-add-to-cart__drop-down-arrow--is-open': sizeDropDownIsOpen.value }])
              }, null, 2)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: _normalizeClass(["primary-button floating-add-to-cart__add-to-cart", {
            'floating-add-to-cart__add-to-cart--coming-soon': _unref(isComingSoon),
          }]),
          onClick: addToCart,
          disabled: !_unref(selectedSizeHasStock)
        }, _toDisplayString(_unref(buttonLabel)), 11, _hoisted_14)
      ], 512)
    ]),
    _createElementVNode("div", _hoisted_15, [
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("img", {
          src: _imports_1,
          class: "floating-add-to-cart__header-back",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (sizeGuideOpen.value = false))
        }),
        _createTextVNode(" " + _toDisplayString(_unref(websiteText)('floating_add_to_cart__back').value) + " ", 1),
        _createElementVNode("img", {
          src: _imports_0,
          class: "floating-add-to-cart__guides-modal-close",
          onClick: _cache[6] || (_cache[6] = ($event: any) => (close()))
        })
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createVNode(SizeGuideAccordion, { class: "floating-add-to-cart__size-guide-accordion" })
      ])
    ])
  ], 2))
}
}

})